import { JobType, Routing, Search } from "@common/_constants";
import { formatClientRoute } from "@common/_services";
import { SearchServiceUtils } from "@common/_services/searchutils.service";
import { StringUtil } from "@common/_services/string.service";
import { Error } from "@common/components/Atoms/Error";
import { AttachmentLink, TelLink } from "@common/components/Atoms/Links";
import Loading from "@common/components/Atoms/Loading";
import LocalTime from "@common/components/Atoms/LocalTime";
import RelodeRep from "@common/components/Atoms/RelodeRep";
import Detail from "@common/components/Molecules/Detail";
import { RewardDetails } from "@common/containers/Modals/RewardDetails";
import { GetEmptyJob, Job as JobModel } from "@common/models";
import { GlobalConfig } from "@common/utils";
import { JobService } from "@pro/_services";
import { SettingsService } from "@pro/_services/settings.service";
import CountBlockContainer from "@pro/components/Atoms/CountBlock";
import MessageSummary from "@pro/components/Atoms/MessageSummary";
import CustomTextJobQualificationList from "@pro/components/Molecules/CustomTextJobQualification";
import CustomYesNoJobQualificationList from "@pro/components/Molecules/CustomYesNoJobQualification";
import EducationJobQualificationList from "@pro/components/Molecules/EducationJobQualificationList";
import LicenseJobQualificationList from "@pro/components/Molecules/LicenseJobQualificationList";
import SkillJobQualificationList from "@pro/components/Molecules/SkillJobQualificationList";
import VideoJobQualificationList from "@pro/components/Molecules/VideoJobQualification";
import {
    JobDetailActions,
    JobDetailCompanyName,
    JobDetailFooter,
    JobDetailSummary,
} from "@pro/components/Organisms/JobDetail";
import { ApplyForJob, ApplyThankYou } from "@pro/containers/Modals/Apply";
import { ReferCandidate } from "@pro/containers/Modals/Refer";
import { ReferThankYou } from "@pro/containers/Modals/ReferThankYou";
import { SendMessage } from "@pro/containers/Modals/SendMessage";
import { ShareJob } from "@pro/containers/Modals/ShareJob";
import { ShowCompanyAgreement } from "@pro/containers/Modals/ShowCompanyAgreement";
import { PageInternal } from "@pro/containers/PageInternal";
import { Button } from "common/components/Atoms/Button";
import qs from "qs";
import * as React from "react";
import { Link, RouteComponentProps } from "react-router-dom";

import { LeaveJob } from "../Modals/LeaveJob";

interface CountDataPoint {
    count: number;
    label: string;
    action: (string) => void;
}

interface JobState {
    job: JobModel;
    error?: {
        message: string;
    };
    loading: boolean;
    bestTimeLoading: boolean;
    isLargeScreen: boolean;
    referResult: {
        jobCandidateId?: number;
    };
    referCandidateModalIsOpen: boolean;
    referThankYouModalIsOpen: boolean;
    applyResult: {
        job_candidate_interest_token: string;
        job_id: number;
        newJobCandidateId: number;
    };
    applyForJobModalIsOpen: boolean;
    applyThankYouModalIsOpen: boolean;
    shareJobModalIsOpen: boolean;
    sendMessageModalIsOpen: boolean;
    leaveJobModalIsOpen: boolean;
    showCompanyAgreementModalIsOpen: boolean;
    rewardDetailsModalIsOpen: boolean;
    shouldShowCompany: boolean;
    userManager: {
        user_id: number;
        display_name: string;
        profile_image_url: string;
        phone_number: string;
    };
    countData: CountDataPoint[];
    [key: string]: any;
}

interface JobProps extends RouteComponentProps<any> {}

export class Job extends React.Component<JobProps, JobState> {
    private _abortControllers: { [key: string]: AbortController } = {};

    queryString: any;

    constructor(props) {
        super(props);

        this.queryString = qs.parse(this.props.location.search, {
            ignoreQueryPrefix: true,
        });

        this.state = {
            job: GetEmptyJob(),
            error: undefined,
            loading: true,
            bestTimeLoading: false,
            isLargeScreen: false,
            referResult: { jobCandidateId: undefined },
            referCandidateModalIsOpen: false,
            referThankYouModalIsOpen: false,
            applyResult: {
                job_candidate_interest_token: "",
                job_id: 0,
                newJobCandidateId: 0,
            },
            applyForJobModalIsOpen: false,
            applyThankYouModalIsOpen: false,
            shareJobModalIsOpen: false,
            sendMessageModalIsOpen: false,
            leaveJobModalIsOpen: false,
            showCompanyAgreementModalIsOpen: false,
            rewardDetailsModalIsOpen: false,
            shouldShowCompany: false,
            userManager: {
                display_name: "",
                phone_number: "",
                profile_image_url: "",
                user_id: 0,
            },
            countData: [] as CountDataPoint[],
        };

        this.buildCountData = this.buildCountData.bind(this);
        this.showCompany = this.showCompany.bind(this);
        this.goToReferral = this.goToReferral.bind(this);
        this.goToJobList = this.goToJobList.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.signAgreement = this.signAgreement.bind(this);
        this.onLeaveJobOkay = this.onLeaveJobOkay.bind(this);
        this.onReferCandidateOkay = this.onReferCandidateOkay.bind(this);
        this.onReferThankYouViewJobs = this.onReferThankYouViewJobs.bind(this);
        this.onReferThankYouGoToReferral = this.onReferThankYouGoToReferral.bind(
            this
        );
        this.onApplyOkay = this.onApplyOkay.bind(this);
        this.onApplyViewJobs = this.onApplyViewJobs.bind(this);
        this.onApplyGoToApplication = this.onApplyGoToApplication.bind(this);
        this.openSendMessage = this.openSendMessage.bind(this);
        this.fetchPageData = this.fetchPageData.bind(this);
    }

    componentWillMount() {
        const jobId = this.props.match.params.id;
        this.fetchPageData(jobId);

        this.setState({
            isLargeScreen: window.matchMedia(
                "(min-width:" + GlobalConfig.ui.breakpoints.md + "px)"
            ).matches,
        });
        window.onresize = () => {
            this.setState({
                isLargeScreen: window.matchMedia(
                    "(min-width:" + GlobalConfig.ui.breakpoints.md + "px)"
                ).matches,
            });
        };
    }

    componentWillUnmount() {
        const abortControllers = this._abortControllers;
        if (Object.keys(abortControllers).length > 0) {
            Object.keys(abortControllers).map(key =>
                abortControllers[key].abort()
            );
        }
    }

    buildCountData(job: JobModel): CountDataPoint[] {
        const goToReferrals = facet => () =>
            this.props.history.push(
                `/referrals?${Search.FacetType.JOB_CANDIDATE_PHASE.key}=${facet}&job_id=${job.job_id}`
            );

        return [
            {
                count: job.reviewed_referrals || 0,
                label: "review",
                action: goToReferrals(Search.JobCandidatePhase.REVIEW),
            },
            {
                count: job.considered_referrals || 0,
                label: "consideration",
                action: goToReferrals(Search.JobCandidatePhase.CONSIDERATION),
            },
            {
                count: job.eliminated_referrals || 0,
                label: "eliminated",
                action: goToReferrals(Search.JobCandidatePhase.ELIMINATED),
            },
            {
                count: job.hired_referrals || 0,
                label: "hired",
                action: goToReferrals(Search.JobCandidatePhase.HIRED),
            },
        ];
    }

    fetchPageData(jobId) {
        this.setState({ loading: true }, () => {
            this._abortControllers.JobServiceGet = new AbortController();
            const jobSignal = this._abortControllers.JobServiceGet.signal;
            const jobP = JobService.get(jobId, jobSignal);

            this._abortControllers.getManager = new AbortController();
            const getManagerSignal = this._abortControllers.getManager.signal;
            const userP = SettingsService.getManager(getManagerSignal);

            Promise.all([jobP, userP])
                .then(values => {
                    const job = values[0];
                    const userManager = values[1];
                    const countData = this.buildCountData(job);
                    this.setState({
                        job,
                        userManager,
                        countData,
                        loading: false,
                        referCandidateModalIsOpen:
                            !!this.queryString &&
                            this.queryString.op === "refer",
                    });
                })
                .catch(error => {
                    if (error.type === "abort" || error.name === "AbortError") {
                        this.setState({ loading: false });
                        return;
                    }
                    this.props.history.push(Routing.Client.Pro.Error.NOT_FOUND);
                    window.scrollTo(0, 0);
                });
        });
    }

    showCompany() {
        this.setState({ shouldShowCompany: true });
    }

    goToApplication = id => {
        this.props.history.push("/applications/" + id);
    };

    goToReferral(id) {
        this.props.history.push("/referrals/" + id);
    }

    goToJobList() {
        this.props.history.push("/jobs");
    }

    openModal(modal) {
        this.setState({ [modal]: true });
    }

    closeModal(modal) {
        this.setState({ [modal]: false });
    }

    signAgreement() {
        let job_id = 0;
        if (!this.state.job) {
            return;
        }
        job_id = this.state.job.job_id;

        this.setState({ loading: true }, () => {
            JobService.signAgreement(job_id)
                .then(() => this.fetchPageData(job_id))
                .catch(error =>
                    this.setState(prevState => ({ error, loading: false }))
                );
        });
    }

    onLeaveJobOkay() {
        this.closeModal("leaveJobModalIsOpen");
        this.goToJobList();
    }

    onReferCandidateOkay(jobCandidateId) {
        this.setState({ referResult: { jobCandidateId } }, () => {
            this.closeModal("referCandidateModalIsOpen");
            this.openModal("referThankYouModalIsOpen");
        });
    }

    onReferThankYouViewJobs() {
        this.closeModal("referThankYouModalIsOpen");
        this.goToJobList();
    }

    onReferThankYouGoToReferral() {
        this.closeModal("referThankYouModalIsOpen");
        this.goToReferral(this.state.referResult.jobCandidateId);
    }

    onApplyOkay(result) {
        this.setState({ applyResult: result }, () => {
            this.closeModal("applyForJobModalIsOpen");
            this.openModal("applyThankYouModalIsOpen");
        });
    }

    onApplyViewJobs() {
        this.closeModal("applyThankYouModalIsOpen");
        this.goToJobList();
    }

    onApplyGoToApplication(jobCandidateId?: number) {
        this.closeModal("applyThankYouModalIsOpen");
        this.goToApplication(
            jobCandidateId || this.state.applyResult.newJobCandidateId
        );
    }

    openSendMessage() {
        this.openModal("sendMessageModalIsOpen");
    }

    render() {
        const {
            job,
            countData,
            error,
            loading,
            bestTimeLoading,
            isLargeScreen,
            referCandidateModalIsOpen,
            referThankYouModalIsOpen,
            applyForJobModalIsOpen,
            applyThankYouModalIsOpen,
            shareJobModalIsOpen,
            sendMessageModalIsOpen,
            leaveJobModalIsOpen,
            showCompanyAgreementModalIsOpen,
            rewardDetailsModalIsOpen,
            shouldShowCompany,
            userManager,
        } = this.state;

        const hasBackground =
            job !== null &&
            !StringUtil.isNullOrWhitespace(job.team_broadcast_background);

        if (loading) {
            return (
                <PageInternal title="jobs">
                    <Loading />
                </PageInternal>
            );
        }

        if (error) {
            return (
                <PageInternal title="jobs">
                    <Error show={!!error} description={error.message} />
                </PageInternal>
            );
        }

        const jobDetailNav = [
            job.user_has_access && "referrals",
            job.user_has_access && "messages",
            job.job_description && "internal notes",
            job.job_qualifications && "qualifications",
            "overview",
            job.has_benefits && "benefits",
            hasBackground && "company",
            !!job.attachments && job.attachments.length > 0 && "attachments",
        ].filter(Boolean);

        const jobLocationLink = (
            <Link
                to={SearchServiceUtils.searchOptionsToLocation(
                    Routing.Client.Pro.Jobs.SEARCH,
                    {
                        location: job.location_id,
                    }
                )}
            >
                {job.location}
            </Link>
        );

        const jobDetailMeta = {
            listItems: [] as React.ReactNode[],
            listItemClass: "job-meta-list-item",
        };

        if (!isLargeScreen && job.is_open) {
            jobDetailMeta.listItems.push(
                job.total_commission_in_us_dollars + " reward"
            );

            if (
                job.job_type_id !== JobType.CONTRACT &&
                job.job_type_id !== JobType.LOCUM
            ) {
                jobDetailMeta.listItems.push(
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <div>{job.employment_guarantee} guarantee</div>
                        <div>
                            {job.employment_guarantee_payment} payment
                            installments
                        </div>
                    </div>
                );
            }
        }

        jobDetailMeta.listItems.push(jobLocationLink);

        const qualifications = () => {
            if (
                job.job_qualifications.required_count < 1 &&
                job.job_qualifications.preferred_count < 1
            ) {
                return null;
            }

            return (
                <div className="c-block__paper">
                    <h2
                        id="qualifications"
                        className="c-block__title--spacingBottom"
                    >
                        qualifications
                    </h2>

                    {job.job_qualifications.required_count > 0 ? (
                        <div>
                            <h3 className="c-job-detail__qual-title">
                                required
                            </h3>
                            <ul className="c-quals-list">
                                <EducationJobQualificationList
                                    educationJobQualifications={job.job_qualifications.education_job_qualifications.filter(
                                        q => q.is_required
                                    )}
                                />

                                <SkillJobQualificationList
                                    skillJobQualifications={job.job_qualifications.skill_job_qualifications.filter(
                                        q => q.is_required
                                    )}
                                />

                                <SkillJobQualificationList
                                    skillJobQualifications={job.job_qualifications.skill_any_of_job_qualifications.filter(
                                        q => q.is_required
                                    )}
                                />

                                <LicenseJobQualificationList
                                    licenseJobQualifications={job.job_qualifications.license_job_qualifications.filter(
                                        jq => jq.is_required
                                    )}
                                />

                                <LicenseJobQualificationList
                                    licenseJobQualifications={job.job_qualifications.license_any_of_job_qualifications.filter(
                                        jq => jq.is_required
                                    )}
                                />

                                <CustomYesNoJobQualificationList
                                    customYesNoJobQualifications={job.job_qualifications.custom_yes_no_job_qualifications.filter(
                                        jq => jq.is_required
                                    )}
                                />

                                <CustomTextJobQualificationList
                                    customTextJobQualifications={job.job_qualifications.custom_text_job_qualifications.filter(
                                        jq => jq.is_required
                                    )}
                                />

                                <VideoJobQualificationList
                                    videoJobQualifications={job.job_qualifications.video_job_qualifications.filter(
                                        jq => jq.is_required
                                    )}
                                />
                            </ul>
                        </div>
                    ) : null}

                    {job.job_qualifications.preferred_count > 0 ? (
                        <div>
                            <h3 className="c-job-detail__qual-title">
                                preferred
                            </h3>
                            <ul className="c-quals-list">
                                <EducationJobQualificationList
                                    educationJobQualifications={job.job_qualifications.education_job_qualifications.filter(
                                        q => !q.is_required
                                    )}
                                />

                                <SkillJobQualificationList
                                    skillJobQualifications={job.job_qualifications.skill_job_qualifications.filter(
                                        q => !q.is_required
                                    )}
                                />

                                <SkillJobQualificationList
                                    skillJobQualifications={job.job_qualifications.skill_any_of_job_qualifications.filter(
                                        q => !q.is_required
                                    )}
                                />

                                <LicenseJobQualificationList
                                    licenseJobQualifications={job.job_qualifications.license_job_qualifications.filter(
                                        jq => !jq.is_required
                                    )}
                                />

                                <LicenseJobQualificationList
                                    licenseJobQualifications={job.job_qualifications.license_any_of_job_qualifications.filter(
                                        jq => !jq.is_required
                                    )}
                                />

                                <CustomYesNoJobQualificationList
                                    customYesNoJobQualifications={job.job_qualifications.custom_yes_no_job_qualifications.filter(
                                        jq => !jq.is_required
                                    )}
                                />

                                <CustomTextJobQualificationList
                                    customTextJobQualifications={job.job_qualifications.custom_text_job_qualifications.filter(
                                        jq => !jq.is_required
                                    )}
                                />

                                <VideoJobQualificationList
                                    videoJobQualifications={job.job_qualifications.video_job_qualifications.filter(
                                        jq => !jq.is_required
                                    )}
                                />
                            </ul>
                        </div>
                    ) : null}
                </div>
            );
        };

        const jobTypeLink = (
            <Link
                to={SearchServiceUtils.searchOptionsToLocation(
                    Routing.Client.Pro.Jobs.SEARCH,
                    {
                        job_type: job.job_type_id,
                    }
                )}
            >
                {job.job_type}
            </Link>
        );
        jobDetailMeta.listItems.push(jobTypeLink);

        if (job.duration_details) {
            jobDetailMeta.listItems.push(
                job.duration_details.map((x, i) => <div key={i}>({x})</div>)
            );
        }

        if (job.job_salary_description) {
            jobDetailMeta.listItems.push(
                <div>{job.job_salary_description}</div>
            );
        }

        if (!isLargeScreen && job.is_open) {
            jobDetailMeta.listItems.push(
                job.open_positions +
                    " opening" +
                    (job.open_positions === 1 ? "" : "s")
            );
        }

        if (job.company_name) {
            jobDetailMeta.listItems.push(
                <JobDetailCompanyName
                    job={job}
                    shouldShowCompany={shouldShowCompany}
                    openModal={modal => this.openModal(modal)}
                />
            );
        }

        const jobSubTitleLinks = (
            <React.Fragment>
                <Link
                    to={SearchServiceUtils.searchOptionsToLocation(
                        Routing.Client.Pro.Jobs.SEARCH,
                        {
                            category: job.primary_job_category_id,
                        }
                    )}
                >
                    {job.primary_job_category_name}
                </Link>
                <span>: </span>
                <Link
                    to={SearchServiceUtils.searchOptionsToLocation(
                        Routing.Client.Pro.Jobs.SEARCH,
                        {
                            category: job.primary_job_category_id,
                            position: job.primary_job_position_id,
                        }
                    )}
                >
                    {job.primary_job_position_name}
                </Link>
            </React.Fragment>
        );

        const secondaryPositionLinks = () => {
            return (
                <React.Fragment>
                    {job.secondary_job_positions.map((value, index) => {
                        return (
                            <div key={index}>
                                <Link
                                    to={SearchServiceUtils.searchOptionsToLocation(
                                        Routing.Client.Pro.Jobs.SEARCH,
                                        { category: value.category_id }
                                    )}
                                >
                                    {value.category_name}
                                </Link>
                                <span>: </span>
                                <Link
                                    to={SearchServiceUtils.searchOptionsToLocation(
                                        Routing.Client.Pro.Jobs.SEARCH,
                                        {
                                            category: value.category_id,
                                            position: value.position_id,
                                        }
                                    )}
                                >
                                    {value.position_name}
                                </Link>
                            </div>
                        );
                    })}
                </React.Fragment>
            );
        };

        return (
            <PageInternal size="lg" headerTitle={job.job_name}>
                <Detail
                    ribbon={null}
                    nav={jobDetailNav}
                    title={job.job_name}
                    meta={jobDetailMeta}
                    actions={
                        <JobDetailActions
                            job={job}
                            signAgreement={this.signAgreement}
                        />
                    }
                    summary={
                        <JobDetailSummary
                            job={job}
                            openModal={this.openModal}
                            signAgreement={this.signAgreement}
                            openSendMessage={this.openSendMessage}
                            userManager={userManager}
                        />
                    }
                    footer={
                        <JobDetailFooter job={job} openModal={this.openModal} />
                    }
                >
                    {!isLargeScreen && !job.is_open && (
                        <div className="c-block">
                            <h2 className="c-block__title">
                                this job is closed/paused
                            </h2>
                            <p>
                                This job is not accepting referrals at this
                                time.
                            </p>
                            <p>
                                Please refer candidates to{" "}
                                <Link
                                    to="/jobs"
                                    className="c-link c-link--magenta"
                                >
                                    another position
                                </Link>
                                .
                            </p>
                        </div>
                    )}

                    {job.application_id && job.application_status && (
                        <div id="your-application" className="c-block">
                            <h2 className="c-block__title">
                                your application stage
                            </h2>
                            <div>
                                Your application is now in{" "}
                                <a
                                    className="c-link c-link--magenta"
                                    href={formatClientRoute(
                                        Routing.Client.Pro.BASE +
                                            Routing.Client.Pro.Applications
                                                .DETAILS,
                                        { id: job.application_id }
                                    )}
                                >
                                    {job.application_status}
                                </a>{" "}
                                stage.
                            </div>
                        </div>
                    )}

                    {!isLargeScreen &&
                        job.user_has_access &&
                        userManager.user_id && (
                            <div className="c-block">
                                <div className="c-block__title">questions?</div>
                                <RelodeRep
                                    image={userManager.profile_image_url}
                                    name={userManager.display_name}
                                >
                                    {userManager.phone_number && (
                                        <TelLink
                                            display={userManager.phone_number}
                                            tel={userManager.phone_number}
                                        />
                                    )}
                                </RelodeRep>
                                <div className="">
                                    <a
                                        className="c-link c-link--magenta"
                                        onClick={() =>
                                            this.openModal(
                                                "sendMessageModalIsOpen"
                                            )
                                        }
                                    >
                                        send message
                                    </a>
                                </div>
                            </div>
                        )}

                    {job.user_has_access && (
                        <CountBlockContainer
                            title="referrals"
                            countData={countData}
                            jobId={job.job_id}
                        />
                    )}

                    {job.user_has_access && (
                        <MessageSummary
                            jobId={job.job_id}
                            total={job.total_messages}
                            unread={job.unread_messages}
                            // onSendMessage={this.openSendMessage}
                        />
                    )}

                    {job.job_description && (
                        <div className="c-block__paper">
                            <h2
                                id="internal-notes"
                                className="c-block__title--spacingbottom"
                            >
                                internal notes
                            </h2>
                            <div className="c-block__preline">
                                {job.job_description}
                            </div>
                        </div>
                    )}

                    {qualifications()}

                    <div className="c-block__paper">
                        <h2
                            id="overview"
                            className="c-block__title--spacingBottom"
                        >
                            overview
                        </h2>
                        <div className="c-block__preline">
                            {job.broadcast_description}
                        </div>
                        <h4>job positions</h4>
                        <React.Fragment>
                            {jobSubTitleLinks}
                            {secondaryPositionLinks()}
                        </React.Fragment>
                    </div>

                    {job.has_benefits && (
                        <div id="benefits" className="c-block__paper">
                            <h2
                                id="job-benefits"
                                className="c-block__title--spacingBottom"
                            >
                                benefits
                            </h2>
                            <div className="c-block--benefitList">
                                <ul className="c-block--benefitList__meta">
                                    {job.benefits &&
                                        job.benefits.map((benefit, i) => (
                                            <div
                                                className="c-block--benefitList__border"
                                                key={i}
                                            >
                                                <li>
                                                    <span>{benefit}</span>
                                                </li>
                                            </div>
                                        ))}
                                </ul>
                            </div>
                        </div>
                    )}

                    {hasBackground && (
                        <div className="c-block__paper">
                            <h2
                                id="company"
                                className="c-block__title--spacingBottom"
                            >
                                company
                            </h2>
                            <div className="c-block__preline">
                                {job.team_broadcast_background}
                            </div>
                        </div>
                    )}

                    {job.attachments && job.attachments.length > 0 && (
                        <div className="c-block">
                            <h2 id="attachments" className="c-block__title">
                                attachments
                            </h2>
                            <div className="c-block__preline">
                                {job.attachments.map((att, i) => (
                                    <AttachmentLink
                                        key={i}
                                        icon={true}
                                        url={att.file_uri}
                                        label={att.file_name}
                                        type={att.content_type}
                                        date={
                                            <LocalTime
                                                utcTimestamp={att.timestamp}
                                            />
                                        }
                                        style={{ margin: "24px 0" }}
                                    />
                                ))}
                            </div>
                        </div>
                    )}

                    {job.user_has_access && (
                        <div className="c-block">
                            <Button
                                id="button-remove-from-my-jobs"
                                onClick={() =>
                                    this.openModal("leaveJobModalIsOpen")
                                }
                            >
                                remove from my jobs
                            </Button>
                        </div>
                    )}
                </Detail>

                <ReferCandidate
                    isOpen={referCandidateModalIsOpen}
                    job={job}
                    onOkay={this.onReferCandidateOkay}
                    onCancel={() =>
                        this.closeModal("referCandidateModalIsOpen")
                    }
                    closeModal={() =>
                        this.closeModal("referCandidateModalIsOpen")
                    }
                />

                <ReferThankYou
                    isOpen={referThankYouModalIsOpen}
                    job={job}
                    onViewJobs={this.onReferThankYouViewJobs}
                    onGoToReferral={this.onReferThankYouGoToReferral}
                    closeModal={() => {
                        this.closeModal("referThankYouModalIsOpen");
                        this.fetchPageData(job.job_id);
                    }}
                />

                <ApplyForJob
                    isOpen={applyForJobModalIsOpen}
                    job={job}
                    onOkay={this.onApplyOkay}
                    onViewJobs={this.onApplyViewJobs}
                    onGoToApplication={this.onApplyGoToApplication}
                    onCancel={() => this.closeModal("applyForJobModalIsOpen")}
                    closeModal={() => this.closeModal("applyForJobModalIsOpen")}
                />

                <ApplyThankYou
                    isOpen={applyThankYouModalIsOpen}
                    job={job}
                    onViewJobs={this.onApplyViewJobs}
                    onGoToApplication={this.onApplyGoToApplication}
                    closeModal={() => {
                        this.closeModal("applyThankYouModalIsOpen");
                        this.fetchPageData(job.job_id);
                    }}
                />

                <ShareJob
                    isOpen={shareJobModalIsOpen}
                    job={job}
                    closeModal={() => this.closeModal("shareJobModalIsOpen")}
                />

                {job.user_has_access && (
                    <SendMessage
                        isOpen={sendMessageModalIsOpen}
                        contextJobId={job.job_id}
                        contextJobName={job.job_name}
                        toUserIds={[userManager.user_id]}
                        forceSelectedIds={true}
                        onCancel={() =>
                            this.closeModal("sendMessageModalIsOpen")
                        }
                        closeModal={() =>
                            this.closeModal("sendMessageModalIsOpen")
                        }
                    />
                )}

                {job.user_has_access && (
                    <LeaveJob
                        isOpen={leaveJobModalIsOpen}
                        jobId={job.job_id}
                        jobName={job.job_name}
                        onOkay={this.onLeaveJobOkay}
                        onCancel={() => this.closeModal("leaveJobModalIsOpen")}
                        closeModal={() =>
                            this.closeModal("leaveJobModalIsOpen")
                        }
                    />
                )}

                {job.company_name && (
                    <ShowCompanyAgreement
                        isOpen={showCompanyAgreementModalIsOpen}
                        onOkay={() => {
                            this.showCompany();
                            this.closeModal("showCompanyAgreementModalIsOpen");
                        }}
                        onCancel={() =>
                            this.closeModal("showCompanyAgreementModalIsOpen")
                        }
                        closeModal={() =>
                            this.closeModal("showCompanyAgreementModalIsOpen")
                        }
                    />
                )}
                <RewardDetails
                    isOpen={rewardDetailsModalIsOpen}
                    closeModal={() =>
                        this.closeModal("rewardDetailsModalIsOpen")
                    }
                    rewardDetails={job}
                />
            </PageInternal>
        );
    }
}
